import React from 'react';
import Auth from "../../components/Auth/Auth";

const AuthPage = () => {
  return <Auth />;
};

export default AuthPage;
